import React from "react";
import ErrorOccured from "./error_occured";

class ErrorClass extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false, errorInfo: null};
    };

    static getDerivedStateFromError(error) {
        return {hasError: true};
    };

    componentDidCatch(error, errorInfo) {
        console.log("Error Class Info: ", error, errorInfo);
    }; 

    render() {
        if (this.state.hasError) {
            return <ErrorOccured />
        };

        return this.props.children;
    };
};

export default ErrorClass;